module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_3.0e0db8dd.png";